/**
 * 租户配置
 * 用于多租户数据隔离：国内(cn) / 国际(intl)
 */

// 租户类型
export type TenantId = 'cn' | 'intl';

// 租户配置
export const TENANT_CONFIG: Record<TenantId, {
  id: TenantId;
  name: string;
  displayName: string;
  defaultLanguage: string;
  flag: string;
  logo?: string;
}> = {
  cn: {
    id: 'cn',
    name: '国内',
    displayName: 'China',
    defaultLanguage: 'zh',
    flag: '🇨🇳',
    logo: '/logo-cn.png',
  },
  intl: {
    id: 'intl',
    name: '国际',
    displayName: 'International',
    defaultLanguage: 'en',
    flag: '🌍',
    logo: '/logo-intl.png',
  },
};

// 获取所有租户ID列表
export const getAllTenants = (): TenantId[] => Object.keys(TENANT_CONFIG) as TenantId[];

// 获取所有租户配置列表
export const getAllTenantConfigs = () => Object.values(TENANT_CONFIG);

// 获取租户配置
export const getTenantConfig = (tenantId: TenantId) => TENANT_CONFIG[tenantId];

// 默认租户
export const DEFAULT_TENANT: TenantId = 'cn';
